<template>
  <div class="report-plate-select-container">
    <template v-for="(item, i) in list">
      <div :key="item.name" class="report-type-box" @click="startDesign(item.type)" v-show="i!==1">
        <img :src="item.src" alt="">
        <div>{{ item.name }}</div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'reportPlateSelect',
  data () {
    return {
      list: [
        {src: require('./assets/common-report.png'), name: '数据报表', type: 0},
        {src: require('./assets/function-report.png'), name: '功能报表', type: 1},
        {src: require('./assets/histogram.png'), name: '柱形图', type: 2},
        {src: require('./assets/pie.png'), name: '饼状图', type: 3},
        {src: require('./assets/line.png'), name: '折线图', type: 4},
        {src: require('./assets/billboard.png'), name: '看板', type: 7},
        {src: require('./assets/custom-page.png'), name: '自定义页面', type: 5}

      ]
    }
  },
  methods: {
    startDesign (index) {
      this.$emit('startDesign', index)
    }
  }
}
</script>

<style lang="scss">
  .report-plate-select-container {
    width: 100%;
    height: 100%;
    background-color: #fff;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    padding: 13px 0 0 21px;
    .report-type-box {
      margin: 0 9px 8px 0;
      box-sizing: border-box;
      cursor: pointer;
      text-align: center;
      border: 1px solid #fff;
      width: 100px;
      height: 90px;
      padding-top: 4px;
      image {
        width: 88px;
        height: 60px;
      }
      &:hover {
        border-color: #55ACF1;
        color: #55ACF1;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/report/design/report-plate-select.vue